import { render, staticRenderFns } from "./AssetSnapshotView.vue?vue&type=template&id=387e8c53&scoped=true"
import script from "./AssetSnapshotView.vue?vue&type=script&lang=js"
export * from "./AssetSnapshotView.vue?vue&type=script&lang=js"
import style0 from "./AssetSnapshotView.vue?vue&type=style&index=0&id=387e8c53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e8c53",
  null
  
)

export default component.exports